import type { RegionCode } from 'google-libphonenumber';
import { PhoneUtil } from './phoneNumber.service';

export interface Country {
  countryCode: `+${number}`;
  fullName: string;
  isoCode: RegionCode;
}
const REGION_NAMES = new Intl.DisplayNames(['en'], { type: 'region' });

let countries = [] as Country[];

export const getCountryFullName = (isoCode: RegionCode) => REGION_NAMES.of(isoCode);

export const getCountries = () => {
  if (countries.length) return countries;
  const isoCodes = PhoneUtil.getSupportedRegions();
  countries = isoCodes
    .map((isoCode) => {
      const countryCode = `+${PhoneUtil.getCountryCodeForRegion(isoCode)}` as const;
      const fullName = getCountryFullName(isoCode);
      if (!fullName) throw new Error(`Failed getting country full name with isoCode ${isoCode}`);
      return {
        countryCode,
        fullName,
        isoCode,
      };
    })
    .sort((a, b) => a.fullName.localeCompare(b.fullName));
  return countries;
};
